import { date } from 'quasar'
import columnsValues from '@/HTable/columnsValues'

export default {
  data () {
    return {
      columns: [
        {
          label: 'Дата создания',
          field: 'created_at',
          name: 'created_at',
          sortable: true,
          align: 'left',
          type: 'date',
          format: value => {
            return date.formatDate(value, 'YYYY-MM-DD в HH:mm:ss')
          },
        },
        {
          label: 'ID сервиса',
          field: 'service_id',
          name: 'service_id',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Название сущности',
          field: 'service_type',
          name: 'service_type',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
          format: value => {
            return Object.keys(this.classMap).includes(value)
                   ? this.classMap[value]
                   : value
          },
        },
        {
          label: 'Значение измененного аттрибута',
          field: 'changed_attribute_value',
          name: 'changed_attribute_value',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'IP',
          field: 'ip',
          name: 'ip',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
        },
        {
          label: 'Email пользователя',
          field: 'user',
          name: 'user_email',
          sortable: true,
          filter: '',
          align: 'left',
          type: 'text',
          format: user => {
            return user ? user.email : ''
          },
        },
        {
          label: 'Роль пользователя',
          field: 'user',
          name: 'user_role',
          sortable: true,
          align: 'left',
          type: 'text',
          format: user => {
            return user ? user.role : ''
          },
        },
        {
          label: 'Действие в логе',
          field: 'action',
          name: 'action_type',
          sortable: true,
          filter: [],
          align: 'left',
          type: 'value',
          values: columnsValues.logType,
          format: value => {
            return value.title
          },
        },
      ],
    }
  },

  computed: {
    isSingleLogView () {
      return this.$route.params.hasOwnProperty('id')
    },

    classMap () {
      return {
        'App\\Models\\Project\\ProjectService': 'Услуга',
        'App\\Models\\Project\\Project': 'Проект',
        'App\\Models\\Bill': 'Счёт',
        'Sunrise\\Billing\\Bill\\Notifications\\BillNotification': 'Оповещение',
        'App\\Models\\Project\\ProjectDomain': 'Домен',
        'App\\Models\\Project\\ProjectComments': 'Комментарий проекта',
        'App\\Models\\User': 'Пользователь',
        'App\\Models\\CiLogs': 'Логи',
        'App\\Models\\Project\\ProjectTag': 'Тег проекта',
        'Sunrise\\Billing\\PaymentUserData\\PaymentData': 'Реквизиты пользователя',
        'Sunrise\\Billing\\Transactions\\Transaction': 'Транзакция',
      }
    },
  },

  mounted () {
    let idColumn = {
      label: 'ID проекта',
      field: 'project_id',
      name: 'project_id',
      sortable: true,
      filter: '',
      align: 'left',
      type: 'text',
    }

    if (!this.isSingleLogView) {
      this.columns.splice(1, 0, idColumn)
    }
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/LogsList/mixins/columns.js